import { graphql, useStaticQuery } from "gatsby";
import React, { useCallback, useRef } from "react";
import { SiteDetailsResponseModel } from "@models/site";
import Footer from "./Footer";
import NavBar from "./NavBar";
import Toast from "../Toast/ToastContainer";
import ResponsiveNavBarWrapper from "./MobileNav/ResponsiveNavBarWrapper";
import Banner from "./Banner";
import { WrapperContext } from "../../../context/wrapper";
import { motion } from "framer-motion";

export interface LayoutPropsModel extends React.HTMLAttributes<HTMLDivElement> {
  darkTheme?: boolean;
  showNavBar?: boolean;
  showFooter?: boolean;
}

const Layout: React.FC<React.PropsWithChildren<LayoutPropsModel>> = ({
  darkTheme,
  children,
  showNavBar = true,
  showFooter = true,
  ...rest
}) => {
  const navAndSiteData = useStaticQuery<SiteDetailsResponseModel>(query);

  const { navigation, strapiLayoutBanner } = navAndSiteData ?? {};
  const showBanner = strapiLayoutBanner?.showBanner || false;

  const childAndFooterWrapperRef = useRef<HTMLDivElement | null>(null);

  const refCb = useCallback((node: HTMLDivElement) => {
    if (node) {
      childAndFooterWrapperRef.current = node;
    }
  }, []);

  return (
    <div
      className="max-w-[1900px] overflow-hidden mx-auto shadow-md  flex flex-col h-screen"
      {...rest}
    >
      <Banner bannerData={strapiLayoutBanner} />

      {showNavBar && (
        <div className="hidden xl:block z-50 w-full relative">
          <NavBar
            navigation={navigation}
            darkTheme={!!darkTheme}
            showBanner={showBanner}
          />
        </div>
      )}

      {showNavBar && (
        <div className="block xl:hidden z-50 w-full ">
          <ResponsiveNavBarWrapper
            navigation={navigation}
            darkTheme={!!darkTheme}
            showBanner={showBanner}
          />
        </div>
      )}

      <motion.div
        className="grow overflow-auto"
        id="children_and_footer_wrapper"
        ref={refCb}
      >
        <WrapperContext.Provider
          value={{ wrapperRef: childAndFooterWrapperRef }}
        >
          {children}
          {showFooter && <Footer />}
        </WrapperContext.Provider>
      </motion.div>
      <Toast />
    </div>
  );
};

export default Layout;
export const query = graphql`
  query NavigationQuery {
    strapiLayoutBanner {
      id
      ctaText
      ctaLink
      strapi_id
      text
      showBanner
    }
    site {
      siteMetadata {
        title
      }
    }
    navigation(slug: { eq: "main_header" }) {
      id
      slug
      items {
        data {
          id
          attributes {
            title
            target
            url
            type_of_menu
            children {
              data {
                id
                attributes {
                  url
                  type_of_menu
                  title
                  icon
                  children {
                    data {
                      id
                      attributes {
                        title
                        type_of_menu
                        url
                        border_bottom
                        target
                        icon
                        # children {
                        #   data {
                        #     id
                        #     attributes {
                        #       url
                        #       title
                        #       children {
                        #         data {
                        #           id
                        #           attributes {
                        #             title
                        #             url
                        #             border_left
                        #           }
                        #         }
                        #       }
                        #       border_left
                        #     }
                        #   }
                        # }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
